import { useEffect } from 'react';
import { UserPlatformIds } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

type UserUuidParam =
  | string /* returns data of provided user with uuid */
  | undefined; /* returns data of currently logged user */

const getOldUserIdErrorStatuses = [
  403 /* If user belongs to different organisation than user querying */,
  404 /* If user was not found */,
];

/** @deprecated Use `useOldUserId` instead. */
export function useGetOldUserIdDeprecated(userUuid: UserUuidParam = undefined) {
  const getOldUserId = useAxios(
    (axios, signal) =>
      axios.request<UserPlatformIds>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/user-account/platform-ids`,
        params: userUuid ? { 'user-uuid': userUuid } : undefined,
        validateStatus: (status) =>
          getOldUserIdErrorStatuses.includes(status) || status === 200,
      }),
    { neededOnPageLoad: false }
  );

  return getOldUserId;
}

/** @deprecated Use `OldUserIdRequest` instead. */
export type GetOldUserIdRequestDeprecated = ReturnType<
  typeof useGetOldUserIdDeprecated
>;

type Params = {
  userUuid: string;
};

export function useOldUserId({ userUuid }: Params) {
  const oldUserId = useAxios(
    (axios, signal, { userUuid }: Params) =>
      axios.request<UserPlatformIds>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/user-account/platform-ids`,
        params: { 'user-uuid': userUuid },
      }),
    { neededOnPageLoad: false }
  );

  useEffect(() => {
    oldUserId.execute({ userUuid });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userUuid]);

  return oldUserId;
}

export type OldUserIdRequest = ReturnType<typeof useOldUserId>;
